module.exports = __webpack_public_path__ + "static/media/logo.81eaa180.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/logo.png
// module id = 118
// module chunks = 2